<template>
    <ion-row v-if="name">
        <ion-col>
            <div class="fw-b purple-purple-color">
                {{ name }}
            </div>
        </ion-col>
    </ion-row>

    <ion-row v-if="options && Array.isArray(options)">
        <ion-col>
            <slot name="select" :options="options">
                <select-base
                    class="grey1-grey1-color grey4-grey4-background"
                    style="--original-background: var(--ion-color-grey4)"
                    :placeholder="$t('placeholder.selectSize')"
                >
                    {{ $t('modal.selection') }}
                    <ion-select-option v-for="size of options" :key="size" :value="size">
                        {{ size }}
                    </ion-select-option>
                </select-base>
            </slot>
        </ion-col>
    </ion-row>

    <ion-row class="mt-3" v-if="amount !== undefined">
        <ion-col size="12">
            <input-amount
                v-model="internalAmount"
                :amount-step="amountStep"
            />
        </ion-col>
    </ion-row>

    <ion-row v-if="!isMultiple">
        <ion-col class="coral-coral-color fs-small center-x">
            {{ $t('label.multipleAmount', { target: amountStep ?? 1 }) }}
        </ion-col>
    </ion-row>

    <ion-row v-if="!isMax">
        <ion-col class="coral-coral-color fs-small center-x">
            {{ $t('label.maxAmount', { target: amountMax }) }}
        </ion-col>
    </ion-row>

    <ion-row
        v-if="(showCart || showList)"
        class="center-x"
    >
        <ion-col
            size="6"
            v-if="showCart"
            :class="{'center-x': !showList}"
        >
            <button-base
                :color="ION_VARIANT.CORAL"
                class="fw-b wrap-button tt-none"
                :class="{'mr-2': showList}"
                @click="$emit('cart')"
                :disabled="!isMultiple || !isMax || Boolean(persistentStore.offlineMode) || !amount"
            >
                {{ $t('modal.addCart') }}
            </button-base>
        </ion-col>

        <ion-col
            size="6"
            v-if="showList"
            :class="{
                'center-x': !showCart,
                'ion-justify-content-end d-flex': showCart
            }"
        >
            <button-base
                :color="ION_VARIANT.CORAL"
                :fill="BUTTON_FILL.OUTLINE"
                class="fw-b wrap-button tt-none"
                :class="{'ml-2': showCart}"
                @click="$emit('list')"
                :disabled="!isMultiple || !isMax"
            >
                {{ $t('modal.addList') }}
            </button-base>
        </ion-col>
    </ion-row>
</template>

<script setup lang="ts">
import { BUTTON_FILL, ION_VARIANT } from "@/types/enum/ionicEnum";
import { IonCol, IonRow, IonSelectOption } from "@ionic/vue";
import InputAmount from "@/components/input/InputAmount.vue";
import SelectBase from "@/components/selects/SelectBase.vue";
import ButtonBase from "@/components/button/ButtonBase.vue";
import { usePersistentStore } from "@/stores/persistent";
import { computed } from "vue";

interface AddProductInterface {
    name: string;
    showCart?: boolean;
    showList?: boolean;
    isMultiple?: boolean;
    isMax?: boolean;
    amount?: number
    amountStep?: number;
    amountMax?: number;
    options?: any[]
}

const props = defineProps<AddProductInterface>()
const emit = defineEmits(['cart', 'list', 'update:amount'])

const persistentStore = usePersistentStore()

const internalAmount = computed({
    get: () => {
        return props.amount
    },
    set: (value) => {
        emit('update:amount', value)
    }
})
</script>

<style scoped>

</style>
